export default __webpack_public_path__ + "static/media/cp.ee0b47ee.svg";